import request from '@/utils/request'

const _Prefix = "/street"

// 查询街道信息列表
export function streetList(query) {
    return request({
        url: _Prefix + '/list',
        method: 'get',
        params: query
    })
}


// 查询街道信息详细
export function getStreet(id) {
    return request({
        url: _Prefix + '/' + id,
        method: 'get'
    })
}

// 新增街道信息
export function addStreet(data) {
    return request({
        url: _Prefix,
        method: 'post',
        data: data
    })
}

// 修改街道信息
export function updateStreet(data) {
    return request({
        url: _Prefix,
        method: 'put',
        data: data
    })
}

// 删除街道信息
export function delStreet(ids) {
    return request({
        url: _Prefix + '/' + ids,
        method: 'delete'
    })
}

// 删除街道附号信息
export function delAttached(attachedId) {
    return request({
        url: '/houseInfo/delete/street/attached/'+attachedId,
        method: 'delete'
    })
}